import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/features/auth/AuthProvider";
import { ProfileProvider } from "@/features/profiles/ProfileProvider";
import { ProtectedRoute } from "@/components/routing/ProtectedRoute";
import { PublicOnlyRoute } from "@/components/routing/PublicOnlyRoute";
import { ProfileGate } from "@/components/routing/ProfileGate";
import LandingPage from "@/features/landing/LandingPage";
import LoginPage from "@/features/auth/pages/LoginPage";
import SignupPage from "@/features/auth/pages/SignupPage";
import AuthCallbackPage from "@/features/auth/pages/AuthCallbackPage";
import OnboardingWizardPage from "@/features/onboarding/OnboardingWizardPage";
import DashboardLayout from "@/features/dashboard/DashboardLayout";
import DashboardOverview from "@/features/dashboard/DashboardOverview";
import CardEditorPage from "@/features/cards/CardEditorPage";
import ProfileThemeEditorPage from "@/features/profiles/ProfileThemeEditorPage";
import PublicProfileRoute from "@/features/profiles/PublicProfileRoute";
import IdentityAssetsPage from "@/features/identity-assets/IdentityAssetsPage";
import AnalyticsPage from "@/features/analytics/AnalyticsPage";
import SignaturePage from "@/features/assets/SignaturePage";
import BackgroundPage from "@/features/assets/BackgroundPage";
import HomeScreenPage from "@/features/pwa/HomeScreenPage";
import SettingsHome from "@/features/settings/SettingsHome";
import ProfileEditorPage from "@/features/settings/ProfileEditorPage";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route element={<PublicOnlyRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
      </Route>
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<ProfileGate mode="onboarding" />}>
          <Route path="/onboarding" element={<OnboardingWizardPage />} />
        </Route>
        <Route element={<ProfileGate mode="dashboard" />}>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<DashboardOverview />} />
            <Route path="/dashboard/card" element={<CardEditorPage />} />
            <Route path="/dashboard/profile" element={<ProfileThemeEditorPage />} />
            <Route path="/dashboard/assets" element={<IdentityAssetsPage />} />
            <Route path="/dashboard/signature" element={<SignaturePage />} />
            <Route path="/dashboard/background" element={<BackgroundPage />} />
            <Route path="/dashboard/home-screen" element={<HomeScreenPage />} />
            <Route path="/dashboard/analytics" element={<AnalyticsPage />} />
            <Route path="/dashboard/settings" element={<SettingsHome />} />
            <Route path="/settings/profile" element={<ProfileEditorPage />} />
          </Route>
        </Route>
        <Route path="/settings" element={<Navigate to="/settings/profile" replace />} />
      </Route>
      <Route path="/:slug" element={<PublicProfileRoute />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-center" />
      </ProfileProvider>
    </AuthProvider>
  );
}
